// extracted by mini-css-extract-plugin
var _1 = "Rqa6xuvl3dbihpO6g0sg";
export { _1 as "inviteLinkCopied" }
